export default __webpack_public_path__ + "static/media/6.ddbad7f9.mp4";